export const appStoreLink =
  'https://apps.apple.com/app/hozana/id1477461388?utm_campaign=app_store_Hozana&utm_source=site_Hozana'

export const playStoreLink =
  'https://play.google.com/store/apps/details?id=org.hozana.app&utm_campaign=play_store_Hozana&utm_source=site_Hozana'
